import {useMemo,useState} from 'react';
import {nigeria,nigeriaText} from '../components/public_directory/interactiveSvgData.js';
const normalize=s=>String(s||'').toLowerCase().replace(/[^a-z]/g,'');
export default function COONigeriaMap({states=[],selected,onSelect}){
 const [zoom,setZoom]=useState(1);
 const map=useMemo(()=>new Map(states.map(s=>[normalize(s.state),s])),[states]);
 const names=useMemo(()=>new Map(nigeriaText.map(n=>[normalize(n.name),n])),[]);
 return <div className="coo-ng-map">
  <div className="coo-ng-map__toolbar"><span>FEDERAL REPUBLIC OF NIGERIA · OPERATIONS</span><div>
    <button type="button" onClick={()=>setZoom(v=>Math.min(3,Math.round((v+.2)*10)/10))} aria-label="Zoom map in">+</button>
    <button type="button" onClick={()=>setZoom(v=>Math.max(.75,Math.round((v-.2)*10)/10))} aria-label="Zoom map out">−</button>
    <button type="button" onClick={()=>setZoom(1)} aria-label="Reset map zoom">Reset</button>
  </div></div>
  <div className="coo-ng-map__viewport"><svg viewBox="-15 -12 825 690" role="img" aria-label="Nigeria map with registered company counts" style={{transform:`scale(${zoom})`}}>
   {nigeria.map(region=>{
     const data=map.get(normalize(region.title))||map.get(normalize(region.id==='NG-FC'?'FCT':region.title));
     const selectedRegion=selected===region.title;
     const value=data?.registered||0;
     const fill=value>=100?'#38cfbb':value>=25?'#1c9b97':value>0?'#176c70':'#223f52';
     const label=names.get(normalize(region.title))||(region.id==='NG-FC'?names.get('fct'):null);
     return <g role="button" tabIndex="0" key={region.id} aria-label={`${region.title}, ${value} registered clients`} onClick={()=>onSelect(region.title)}
      onKeyDown={e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();onSelect(region.title);}}} className={selectedRegion?'coo-ng-map__selected':''}>
      <path d={region.d} fill={fill} stroke={selectedRegion?'#f4d28c':'#4d8891'} strokeWidth={selectedRegion?2.7:1.05}><title>{`${region.title}: ${value} registered clients`}</title></path>
      {label&&value>0&&<circle pointerEvents="none" cx={Number(label.x)} cy={Number(label.y)} r="2.3" fill="#e9e7cf"/>}
     </g>;
   })}
  </svg></div>
  <div className="coo-ng-map__footer">Select a state for the existing operational snapshot. Location reflects registered addresses, not GPS presence.</div>
 </div>;
}
